import config from 'config';
import { IncentiveCampaign } from 'core/domains/incentive-campaigns';
import { incentiveCampaigns } from 'core/use-cases';
import { data } from 'ui/containers/Gifts/__data__';

import type { CatalogItem } from './catalog';
import type { AsyncFlowWithData } from './utilities';
import type { CycleUser } from 'core/services/bff';
import type { AsyncFlow } from 'core/utilities';

const { short, environment } = config.app;

export const SHIPPING_MODEL = {
  KEY_ACCOUNT_PICKUP_STORE: 28,
  KEY_ACCOUNT_ORDER_EXPRESS: 26,
  KEY_ACCOUNT_RETROACTIVE: 25,
  KEY_ACCOUNT: 23,
  PICKUP_STORE: config.pickupStore,
  ORDER_EXPRESS: 16,
  RETROACTIVE_RESELLER: config.retroActiveReseller,
  RESELLER: config.reseller,
};

type Available = {
  code: number;
  deliveries: Delivery[];
  name: string;
};

type BusinessModel = {
  availables: Available[];
  default: Default;
};

type Credit = {
  available: string;
  availableNum: number;
  cashback: number;
  notOverdue: number;
  overdue: number;
  toBill: number;
  tolerancePercentage: number;
  total: number;
};

type Contacts = {
  type: string;
  value: string;
};

type Default = {
  code: number;
  delivery: Delivery;
  name: string;
};

type Delivery = {
  address: string;
  distributionCenterCode: number;
  distributionCenterName: string;
  isWithdrawalCenter: boolean;
};

type Supervisor = {
  name: string;
  contacts: Contacts[];
};

type CycleProps = {
  currentCycle: number;
  daysLeft: number;
  daysTotal: number;
  initialDate: string;
  finalDate: string;
  toleranceDays?: number;
  brand?: 'BOTICARIO' | 'EUDORA';
  name?: string;
  isMultiBrand?: boolean;
};

type Cycles = {
  cycles: CycleProps[];
  canChooseCycle: boolean;
  canBuyOnlyInER: boolean;
  status: string;
  message: string;
  flagIsExtendedCaptation: boolean;
};

type IncentiveCampaigns = {
  data: IncentiveCampaign[];
};

type UserData = {
  brand: string;
  cycle: {
    currentCycle: number;
    daysLeft: number;
    daysTotal: number;
    initialDate: string;
    finalDate: string;
    nextCycle: number;
  };
  avaliableCycles: Cycles;
  fullAddress: string;
  isBlocked: boolean;
  isCeased: boolean;
  isMultiBrand: boolean;
  isWithdrawalCenter: boolean;
  name: string;
  region: string;
  resellerId: string;
  shippingModel: BusinessModel;
  supervisor: Supervisor;
  isExtendedCapitation: boolean;
  isResaleIntention: boolean;
  isAutoStartEnabled: boolean;
};

export type User = AsyncFlowWithData<UserData> & {
  buyIntention: AsyncFlow & {
    items: Array<CatalogItem['productCode']>;
  };
  credit: AsyncFlowWithData<Credit>;
  itemAddCartError: Array<CatalogItem['productCode']>;
  shippingModelSearch: string;
  incentiveCampaigns: AsyncFlowWithData<IncentiveCampaignsList>;
};

export type ShippingModelStep = {
  step: Cart['step'];
  defaultShippingModelCode?: number;
  defaultDistributionCenterCode?: number;
};
